import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { combineLatest, Observable } from 'rxjs';
import { filter, first, map, pluck } from 'rxjs/operators';
import { AppState } from 'src/app';
import { selectContractsAccountsAccounts } from 'src/app/state/selectors/contract-accounts-selectors';
import { selectContractId } from 'src/app/state/selectors/current-contract.selectors';

@Component({
  selector: 'hb-terms-and-conditions-global',
  templateUrl: './terms-and-conditions-global.component.html',
  styleUrls: ['./terms-and-conditions-global.component.scss'],
})
export class TermsAndConditionsGlobalComponent {
  public showFullAgreement = false;
  public acceptAgreement = false;
  public hasPreviouslyAcceptedAgreement = false;
  public strategyName$: Observable<string>;

  @Output() private acceptTerms = new EventEmitter<void>();

  constructor(private readonly store: Store<AppState>) {
    this.strategyName$ = this.getCurrentComContractAndAccount$().pipe(
      pluck('name'),
    );
  }

  public toggleShowFullAgreement() {
    this.showFullAgreement = !this.showFullAgreement;
  }

  public toggleAcceptAgreement() {
    this.acceptAgreement = !this.acceptAgreement;
  }

  public handleSubmit() {
    this.acceptTerms.next();
  }

  private getCurrentComContractAndAccount$() {
    return combineLatest(
      this.store.select(selectContractId),
      this.store.select(selectContractsAccountsAccounts),
    ).pipe(
      filter(
        ([contractId, accounts]) =>
          !!contractId && !!accounts && accounts.hasOwnProperty(contractId),
      ),
      map(([contractId, accounts]) => accounts[contractId]),
      first(),
    );
  }
}
